import { useRouteMatch } from 'react-router';

import { getConfig, URLS } from '@constants';

export const useIsAppsSeoPage = () => {
	const match: { params: { id: string } } = useRouteMatch([
		`${getConfig().apps?.pathname}/:id`,
		`${URLS.APPS}./:id`,
		`${getConfig().apps?.pathname}`,
		`${URLS.APPS}`,
	]);
	const params = match?.params;

	return params && /^\d+$/g.test(params?.id || '');
};
